import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import less from "./AadharValidationMarshal.module.scss";
import Loader from "../../components/loader";

const AadharValidationMarshal = () => {
  const location = useLocation();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const result = params.get("status"); // "SUCCESS" or "FAILURE"
    setTimeout(() => {
      setStatus(result);
      setLoading(false);
    }, 2000);
  }, [location.search]);

  const handleOk = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("closeAadharValidation");
    } else if (window.AndroidWebView) {
      window.AndroidWebView.closeAadharValidation();
    } else {
      history.push("/");
    }
  };

  return (
    <div className={less.container}>
      {loading ? (
        <Loader />
      ) : status === "SUCCESS" ? (
        <>
          <div className={less.successCheck}>&#9989;</div>
          <h2>Validation Successful</h2>
        </>
      ) : (
        <>
          <div className={less.failureCross}>&#10060;</div>
          <h2>Validation Failed</h2>
        </>
      )}

      {!loading && <button onClick={handleOk}>OK</button>}
    </div>
  );
};

export default AadharValidationMarshal;
